import { getHostName, convertToUTC } from "../utils";
import { cachedGet } from "./requestCache.js";

export async function fetchPads(query, filter) {
  // const jsonString = encodeURIComponent(JSON.stringify(filter));
  return cachedGet(`pads:${query || ""}`, async () => {
    const data = await fetch(`${getHostName()}/api/pads/?format=json&query=${query}`);
    return data.json();
  });
}

export async function fetchPadInfo(id, startDate) {
  const data = await fetch(
    `${getHostName()}/api/padinformation/?id=${id}${
      startDate ? `&startdate=${convertToUTC(startDate)}` : ""
    }&format=json`
  );

  if (!data.ok) {
    throw new Error("Pad Not Found");
  }

  return await data.json();
}
